import * as React from "react";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import SelectAcquisitionChannel from "../acquisitionChannel/SelectAcquisitionChannel";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import AcquisitionChannel from "../../../model/acquisitionChannel/AcquisitionChannel";
import {Option} from "ts-option";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

type Props = FormGroupProps<string> & PlaceholderProps;

/**
 * Lead acquisition channel form view group.
 */
export default class LeadAcquistionFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<SelectAcquisitionChannel placeholder={this.props.placeholder}
										  selectedId={this.props.field.getOptionalValue()}
										  onChanged={this.onChange}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed acquisition channel.
	 * @param data
	 */
	onChange(data: Option<AcquisitionChannel>) {
		this.props.onChange(this.props.field.updateValue(data.map((ac) => ac.id)))
	}
}
